import React, { createContext, useState, useEffect } from 'react'

import { JOONE_CHARGE_URL } from '../utils/bab/bab.utils'

export const ProductsDataContext = createContext(null)

export const ProductsDataProvider = ({ children }) => {
  const [productsData, setProductsData] = useState(null)

  useEffect(() => {
    /* global Shopify */
    const fetchProductsData = async () => {
      const response = await fetch(
        `${JOONE_CHARGE_URL}/api/products?bab_strict=true&shop=${Shopify.shop}`
      )
      const data = await response.json()
      setProductsData(data)
    }

    fetchProductsData()
  }, [])

  return (
    <ProductsDataContext.Provider value={productsData}>
      {children}
    </ProductsDataContext.Provider>
  )
}
